module.exports = __webpack_public_path__ + "img/xdrs.b31c9a7c.png";